import React from "react";
import { Segment, Button, Header, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <Segment placeholder>
      <Header icon>
        <Icon name="search" />
        Oops - nós procuramos em todo sistema e não encontramos isso.
      </Header>
      <Segment.Inline>
        <Button as={Link} to="/admin/dashboard" primary>
          Pagina Inicial
        </Button>
      </Segment.Inline>
    </Segment>
  );
};

export default NotFound;
